import React from 'react'
import Field from '../../common/FormField'

import styles from '../Form.module.css'

const StorePolicies = ({ data, onChangeFactory, disabled }) =>
  <div>
    <fieldset>
      <h3 className={styles.subSectionTitle}>Tax</h3>
      <div className={styles.subSectionDesc}>
        Enter the appropriate tax rate applied to all of your items. Please
        consult your local tax laws for guidance.
      </div>
      <Field type="input" name="Tax Rate (%)">
        <input
          type="text"
          placeholder="Enter percentage, i.e. 13"
          value={data.taxRate}
          onChange={onChangeFactory('taxRate')}
          disabled={disabled}
        />
      </Field>

      <h3 className={styles.subSectionTitle}>Shipping</h3>
      <div className={styles.subSectionDesc}>
        Select the destinations you ship to, along with the flat shipping fee
        that will be passed on to the buyer. The shipping fee currency will
        automatically match the currency set for the item’s price (i.e. CAD or
        USD).
      </div>
      <Field name="Shipping Destinations">
        <div className="row">
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="shippingDestinationGroup"
                value="international"
                checked={data.shippingDestination === 'international'}
                onChange={onChangeFactory('shippingDestination')}
                disabled={disabled}
              />
              <i />International
            </label>
          </div>
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="shippingDestinationGroup"
                value="north-america"
                checked={data.shippingDestination === 'north-america'}
                onChange={onChangeFactory('shippingDestination')}
                disabled={disabled}
              />
              <i />North America Only
            </label>
          </div>
        </div>
      </Field>
      <Field type="input" name="Flat Shipping Fee">
        <input
          type="text"
          placeholder="Enter flat fee, i.e. 10.99"
          value={data.shippingFee}
          onChange={onChangeFactory('shippingFee')}
          disabled={disabled}
        />
      </Field>

      <h3 className={styles.subSectionTitle}>Returns</h3>
      <Field name="Return Policy">
        <div className="row">
          <div className="col col-8">
            <label className="radio">
              <input
                type="radio"
                name="returnPolicyGroup"
                value="return-accepted"
                checked={data.returnPolicy === 'return-accepted'}
                onChange={onChangeFactory('returnPolicy')}
                disabled={disabled}
              />
              <i />Return Accepted (full refund with item in good condition)
            </label>
          </div>
          <div className="col col-4">
            <label className="radio">
              <input
                type="radio"
                name="returnPolicyGroup"
                value="no-returns"
                checked={data.returnPolicy === 'no-returns'}
                onChange={onChangeFactory('returnPolicy')}
                disabled={disabled}
              />
              <i />No Returns/Refunds
            </label>
          </div>
        </div>
      </Field>
      <Field type="input" name="Return Period (Days)">
        <input
          type="text"
          placeholder="Enter days, i.e. 30"
          value={data.returnPeriod}
          onChange={onChangeFactory('returnPeriod')}
          disabled={disabled}
        />
      </Field>
    </fieldset>
  </div>

export default StorePolicies
